import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {

  toggle_arrow:boolean = false
  constructor(public auth:AuthService, private router : Router, public common:CommonService) { }

  ngOnInit(): void {
  }

  logout(){
    this.auth.logout()
  }
  toggle(){
    // alert("test")
    this.toggle_arrow = !this.toggle_arrow
    if(this.toggle_arrow){
      document.getElementById("toggle_menu").classList.remove("d-none")
      document.getElementById("toggle_menu").classList.add("d-flex")
      document.getElementById("arrow_rotate").classList.remove("rotated_arrow")
      document.getElementById("toggle_menu1").classList.remove("d-none")
      document.getElementById("toggle_menu1").classList.add("d-flex")
      document.getElementById("arrow_rotate1").classList.remove("rotated_arrow")
    }
    else{
      document.getElementById("toggle_menu").classList.remove("d-flex")
      document.getElementById("toggle_menu").classList.add("d-none")
      document.getElementById("arrow_rotate").classList.add("rotated_arrow")
      document.getElementById("toggle_menu1").classList.remove("d-flex")
      document.getElementById("toggle_menu1").classList.add("d-none")
      document.getElementById("arrow_rotate1").classList.add("rotated_arrow")


    }
    // document.getElementById("toggle_menu").classList.add("d-flex")
  }


  goBack(){
    let curr_url = window.location.href
    //console.log(window.history)
    let sub = curr_url.split('//')[1]
    let url = sub.substr(curr_url.split('//')[1].match('/').index)
    // if(window.history.length!=0){
    window.history.back()

    setTimeout(()=>{
      if(curr_url == window.location.href){
        this.router.navigateByUrl('/dashboard')
      }
    },200)
    // }
    // else{
    //     this.router.navigateByUrl('/dashboard')  
    // }
      
  }
}
